import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, Cell, XAxis, YAxis, Tooltip, Legend, ReferenceLine, ResponsiveContainer } from 'recharts';
import OKReferenceLineLabel from 'components/charts/OKReferenceLineLabel/OKReferenceLineLabel';

class OKBarChart extends Component {

    renderBars = () => {
        const { animationBegin, bars, data, fills, lastFills } = this.props;
        return bars.map((bar, index) => {
            return (
                <Bar animationBegin={animationBegin} key={bar} dataKey={bar} >
                    {
                        data.map((entry, i) => {
                            if (lastFills && lastFills.length && data.length - 1 == i) {
                                return <Cell key={i} fill={lastFills[index]} />
                            } else {
                                return <Cell key={i} fill={fills[index]} />
                            }
                        })
                    }
                </Bar>
            )
        })
    }

    render() {
        const {
            axisLine,
            data,
            height,
            interval,
            legend,
            margin,
            referenceLineStroke,
            referenceLineData,
            tooltipContent,
            tooltip,
            unit,
            width,
            xAxis,
            xTickComponent
        } = this.props;

        return (
            <ResponsiveContainer width={width} height={height}>
                <BarChart
                    data={data}
                    margin={margin}
                >
                    <XAxis tickLine={false} dataKey={xAxis} tick={xTickComponent} />
                    <YAxis tickLine={false} interval={interval} axisLine={axisLine} unit={` ${unit}`} />
                    { tooltip && <Tooltip content={tooltipContent} /> }
                    { this.renderBars() }
                    {
                        referenceLineData &&
                            <ReferenceLine
                                label={<OKReferenceLineLabel preLabel={referenceLineData.preLabel} label={referenceLineData.label} />}
                                y={referenceLineData.value}
                                stroke={referenceLineStroke}
                                alwaysShow
                            />
                    }
                    { legend && <Legend /> }
                </BarChart>
            </ ResponsiveContainer>
        );
    }
}

OKBarChart.propTypes = {
    animationBegin: PropTypes.number,
    axisLine: PropTypes.bool,
    bars: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    fills: PropTypes.array,
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    interval: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    lastFills: PropTypes.array,
    legend: PropTypes.bool,
    margin: PropTypes.object,
    referenceLineData: PropTypes.object,
    referenceLineStroke: PropTypes.string,
    tooltip: PropTypes.bool,
    tooltipContent: PropTypes.func,
    unit: PropTypes.string,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    xAxis: PropTypes.string.isRequired,
    xTickComponent: PropTypes.object
};

OKBarChart.defaultProps = {
    fills: [],
    legend: false,
    tooltip: true
}

export default OKBarChart;